// Add class to current navigation link
let navigationLinks = $('.nav-link');
$.each(navigationLinks, function (key, value) {
    if (value.href === document.URL) {
        $(this).addClass('nav-link-active');
    }
});